"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.statusObservable = exports.requiresSatStackReady = exports.checkDescriptorExists = exports.fetchSatStackStatus = exports.isSatStackEnabled = exports.editSatStackConfig = exports.stringifySatStackConfig = exports.parseSatStackConfig = exports.checkRPCNodeConfig = exports.validateRPCNodeConfig = exports.isValidHost = exports.setMockStatus = void 0;
var logs_1 = require("@ledgerhq/logs");
var rxjs_1 = require("rxjs");
var semver_1 = __importDefault(require("semver"));
var url_1 = __importDefault(require("url"));
var operators_1 = require("rxjs/operators");
var errors_1 = require("../../errors");
var currencies_1 = require("../../currencies");
var network_1 = __importDefault(require("../../network"));
var env_1 = require("../../env");
var Ledger_1 = require("../../api/Ledger");
var minVersionMatch = ">=0.11.1";
function isAcceptedVersion(version) {
    return (!!version && semver_1["default"].satisfies(semver_1["default"].coerce(version) || "", minVersionMatch));
}
var mockStatus = {
    type: "ready"
};
function setMockStatus(s) {
    mockStatus = s;
}
exports.setMockStatus = setMockStatus;
function isValidHost(host) {
    var splits = host.split(":");
    if (splits.length > 2)
        return false;
    // domainToASCII returns "" when a domain is invalid
    return Boolean(url_1["default"].domainToASCII(splits[0]));
}
exports.isValidHost = isValidHost;
// we would call this only during the user validation of the rpc node configuration
function validateRPCNodeConfig(config) {
    var errors = [];
    if (!config.host) {
        errors.push({
            field: "host",
            error: new errors_1.RPCHostRequired()
        });
    }
    else if (!isValidHost(config.host)) {
        errors.push({
            field: "host",
            error: new errors_1.RPCHostInvalid()
        });
    }
    if (!config.username) {
        errors.push({
            field: "username",
            error: new errors_1.RPCUserRequired()
        });
    }
    if (!config.password) {
        errors.push({
            field: "password",
            error: new errors_1.RPCPassRequired()
        });
    }
    return errors;
}
exports.validateRPCNodeConfig = validateRPCNodeConfig;
// we would call this only during the "Testing node connection" step
// Check if the node is accessible by RPC. promise fails if not.
function checkRPCNodeConfig(config) {
    return __awaiter(this, void 0, void 0, function () {
        var errors, host, username, password, tls;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    errors = validateRPCNodeConfig(config);
                    if (errors.length) {
                        throw errors[0].error;
                    }
                    if ((0, env_1.getEnv)("MOCK")) {
                        if (mockStatus.type === "node-disconnected") {
                            throw new Error("mock disconnected");
                        }
                        return [2 /*return*/];
                    }
                    host = config.host, username = config.username, password = config.password, tls = config.tls;
                    return [4 /*yield*/, (0, network_1["default"])({
                            url: "http".concat(tls ? "s" : "", "://").concat(host),
                            method: "POST",
                            data: {
                                jsonrpc: "1.0",
                                id: "ledger-live-full-node-check",
                                method: "getblockchaininfo",
                                params: []
                            },
                            auth: {
                                username: username,
                                password: password
                            }
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.checkRPCNodeConfig = checkRPCNodeConfig;
// we would need to call this any time we would "Edit" the flow
function parseSatStackConfig(json) {
    var obj = JSON.parse(json);
    if (obj && typeof obj === "object") {
        var accounts = obj.accounts, rpcurl = obj.rpcurl, rpcuser = obj.rpcuser, rpcpass = obj.rpcpass, notls = obj.notls, extra = __rest(obj, ["accounts", "rpcurl", "rpcuser", "rpcpass", "notls"]);
        if (!rpcurl || typeof rpcurl !== "string")
            return;
        if (!rpcuser || typeof rpcuser !== "string")
            return;
        if (!rpcpass || typeof rpcpass !== "string")
            return;
        var result = {
            node: {
                host: rpcurl,
                username: rpcuser,
                password: rpcpass,
                tls: !notls
            },
            accounts: [],
            extra: extra
        };
        if (accounts && typeof accounts === "object" && Array.isArray(accounts)) {
            result.accounts = accounts
                .map(function (a) {
                var external = a.external, internal = a.internal, extra = __rest(a, ["external", "internal"]);
                if (!external || typeof external !== "string")
                    return;
                if (!internal || typeof internal !== "string")
                    return;
                return {
                    descriptor: {
                        external: external,
                        internal: internal
                    },
                    extra: extra
                };
            })
                .filter(Boolean);
        }
        return result;
    }
}
exports.parseSatStackConfig = parseSatStackConfig;
// we would need this at the end of the setup flow, when we save to a jss.json configuration file
function stringifySatStackConfig(config) {
    return JSON.stringify(__assign({ accounts: config.accounts.map(function (a) { return (__assign({ external: a.descriptor.external, internal: a.descriptor.internal }, a.extra)); }), rpcurl: config.node.host, rpcuser: config.node.username, rpcpass: config.node.password, notls: !config.node.tls }, config.extra), null, 2);
}
exports.stringifySatStackConfig = stringifySatStackConfig;
// We would need it to apply an edition over an existing sats stack configuration (before saving it over)
function editSatStackConfig(existing, edit) {
    var accounts = existing.accounts.concat(
    // append accounts that would not already exist
    (edit.accounts || []).filter(function (a) {
        return !existing.accounts.some(function (existing) { return a.descriptor.internal === existing.descriptor.internal; });
    }));
    return __assign(__assign(__assign({}, existing), edit), { 
        // edit is patching existing fields
        accounts: accounts });
}
exports.editSatStackConfig = editSatStackConfig;
function isSatStackEnabled() {
    return Boolean((0, env_1.getEnv)("SATSTACK"));
}
exports.isSatStackEnabled = isSatStackEnabled;
// We would need it any time we want to check if the Sats Stack is up and what status is it at currently
// - during the configuration flow (on last step) (actively polling)
// - on the settings screen (actively polling)
// - before doing a sync
// - before doing an add account
// NB the promise is never rejected
function fetchSatStackStatus() {
    return __awaiter(this, void 0, void 0, function () {
        var ce, r, _a, chain, status, sync_progress, scan_progress, version;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!isSatStackEnabled()) {
                        return [2 /*return*/, {
                                type: "satstack-disconnected"
                            }];
                    }
                    if ((0, env_1.getEnv)("MOCK")) {
                        return [2 /*return*/, mockStatus];
                    }
                    ce = (0, Ledger_1.getCurrencyExplorer)((0, currencies_1.getCryptoCurrencyById)("bitcoin"));
                    return [4 /*yield*/, (0, network_1["default"])({
                            type: "GET",
                            url: "".concat(ce.endpoint, "/blockchain/").concat(ce.version, "/explorer/status")
                        })["catch"](function () { return null; })];
                case 1:
                    r = _b.sent();
                    if (!r || !r.data) {
                        return [2 /*return*/, {
                                type: "satstack-disconnected"
                            }];
                    }
                    _a = r.data, chain = _a.chain, status = _a.status, sync_progress = _a.sync_progress, scan_progress = _a.scan_progress, version = _a.version;
                    if (!isAcceptedVersion(version)) {
                        return [2 /*return*/, {
                                type: "satstack-outdated"
                            }];
                    }
                    if (chain !== "main") {
                        return [2 /*return*/, {
                                type: "invalid-chain",
                                found: chain
                            }];
                    }
                    if (status === "initializing" || status === "pending-scan") {
                        return [2 /*return*/, {
                                type: "initializing"
                            }];
                    }
                    if (status === "node-disconnected") {
                        return [2 /*return*/, {
                                type: "node-disconnected"
                            }];
                    }
                    if (status === "syncing") {
                        return [2 /*return*/, {
                                type: "syncing",
                                progress: (sync_progress || 0) / 100
                            }];
                    }
                    if (status === "scanning") {
                        return [2 /*return*/, {
                                type: "scanning",
                                progress: (scan_progress || 0) / 100
                            }];
                    }
                    return [2 /*return*/, {
                            type: "ready"
                        }];
            }
        });
    });
}
exports.fetchSatStackStatus = fetchSatStackStatus;
function checkDescriptorExists(descriptor) {
    return __awaiter(this, void 0, void 0, function () {
        var r;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if ((0, env_1.getEnv)("MOCK")) {
                        return [2 /*return*/, true];
                    }
                    return [4 /*yield*/, (0, network_1["default"])({
                            method: "POST",
                            url: "".concat((0, env_1.getEnv)("EXPLORER_SATSTACK"), "/control/descriptors/has"),
                            data: {
                                descriptor: descriptor
                            }
                        })];
                case 1:
                    r = _a.sent();
                    (0, logs_1.log)("satstack", "checkDescriptorExists " + descriptor + " is " + r.data.exists);
                    return [2 /*return*/, Boolean(r.data.exists)];
            }
        });
    });
}
exports.checkDescriptorExists = checkDescriptorExists;
function requiresSatStackReady() {
    return __awaiter(this, void 0, void 0, function () {
        var status_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isSatStackEnabled()) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchSatStackStatus()];
                case 1:
                    status_1 = _a.sent();
                    switch (status_1.type) {
                        case "ready":
                            return [2 /*return*/];
                        case "syncing":
                        case "scanning":
                            throw new errors_1.SatStackStillSyncing();
                        case "satstack-outdated":
                            throw new errors_1.SatStackVersionTooOld();
                        default:
                            throw new errors_1.SatStackAccessDown();
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
exports.requiresSatStackReady = requiresSatStackReady;
exports.statusObservable = (0, rxjs_1.interval)(1000).pipe((0, operators_1.switchMap)(function () { return (0, rxjs_1.from)(fetchSatStackStatus()); }), (0, operators_1.filter)(function (e, i) { return i > 4 || e.type !== "satstack-disconnected"; }), (0, operators_1.share)());
//# sourceMappingURL=satstack.js.map